// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
import { AXIS_WIDTH, PlotLayout } from '@/membership/utilities/chart-geometry';
import { Stack, Typography } from '@mui/material';
import { DateTime } from 'luxon';

interface Props {
  layout: PlotLayout;
  startOn: DateTime;
  endOn: DateTime;
}

/**
 * The window a plot covers, written under its own bars rather than under the
 * scrub bar. Each chart carries one, so a chart can be read without counting
 * back to whichever of them the dates happened to sit beneath.
 */
export function ChartDateAxis(props: Props) {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      sx={{
        marginLeft: `${String(AXIS_WIDTH)}px`,
        width: `${String(props.layout.plotWidth)}px`,
        mt: 0.5,
      }}
    >
      <Typography variant="caption" color="text.secondary">
        {props.startOn.toLocaleString(DateTime.DATE_MED)}
      </Typography>
      <Typography variant="caption" color="text.secondary">
        {props.endOn.toLocaleString(DateTime.DATE_MED)}
      </Typography>
    </Stack>
  );
}
